// components/common/CtaSection/index.tsx
// Call-to-action section dùng chung

import { Link } from 'react-router-dom'

interface CtaButton {
  label: string
  href: string
  icon?: string
  variant?: 'primary' | 'secondary'
  external?: boolean
}

interface CtaSectionProps {
  title: string
  titleHighlight?: string
  description?: string
  buttons?: CtaButton[]
  className?: string
}

const DEFAULT_BUTTONS: CtaButton[] = [
  {
    label: 'Liên Hệ Ngay',
    href: '/lien-he',
    icon: 'fa-phone',
    variant: 'primary',
  },
  {
    label: 'Xem Thêm Dự Án',
    href: '/cong-trinh-thiet-ke',
    icon: 'fa-folder',
    variant: 'secondary',
  },
]

const CtaSection = ({
  title,
  titleHighlight,
  description = 'Liên hệ với chúng tôi để được tư vấn miễn phí và báo giá chi tiết',
  buttons = DEFAULT_BUTTONS,
  className = '',
}: CtaSectionProps) => {
  const renderTitle = () => {
    if (!titleHighlight || !title.includes(titleHighlight)) return title
    const parts = title.split(titleHighlight)
    return (
      <>
        {parts[0]}
        <span>{titleHighlight}</span>
        {parts[1]}
      </>
    )
  }

  return (
    <div className={`cta-wrapper container ${className}`}>
      <div className="cta-section">
        <h2 className="cta-section__title">{renderTitle()}</h2>
        {description && (
          <p className="cta-section__description">{description}</p>
        )}
        <div className="cta-section__buttons">
          {buttons.map((btn, i) => (
            btn.external ? (
              <a
                key={i}
                href={btn.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`btn btn-${btn.variant || 'primary'} btn-lg`}
              >
                {btn.icon && <i className={`fas ${btn.icon}`} />}
                {btn.label}
              </a>
            ) : (
              <Link
                key={i}
                to={btn.href}
                className={`btn btn-${btn.variant || 'primary'} btn-lg`}
              >
                {btn.icon && <i className={`fas ${btn.icon}`} />}
                {btn.label}
              </Link>
            )
          ))}
        </div>
      </div>
    </div>
  )
}

export default CtaSection
